import { useQuery } from 'react-query';
import {
  fetchPrivateLessonBookings,
  fetchPrivateLessonCoaches,
  fetchPrivateLessonSlots,
} from '../fetchers/private-lessons';

export const usePrivateLessonCoaches = (gymUid) => {
  const query = useQuery(['private-lesson-coaches', gymUid], () => fetchPrivateLessonCoaches(gymUid), {
    enabled: !!gymUid,
    refetchOnWindowFocus: false,
  });
  return { coaches: query.data || [], ...query };
};

export const usePrivateLessonSlots = (gymUid, filters, enabled = true) => {
  const query = useQuery(
    ['private-lesson-slots', gymUid, filters],
    () => fetchPrivateLessonSlots(gymUid, filters),
    {
      enabled: !!gymUid && enabled,
      refetchOnWindowFocus: false,
      // Keep the current coach's markers visible while a fresh availability
      // response arrives instead of briefly rendering every date unavailable.
      keepPreviousData: true,
    },
  );
  return { slots: query.data || [], ...query };
};

export const usePrivateLessonBookings = (gymUid, scope) => {
  const query = useQuery(
    ['private-lesson-bookings', gymUid, scope],
    () => fetchPrivateLessonBookings(gymUid, scope),
    { enabled: !!gymUid, refetchOnWindowFocus: false },
  );
  return { bookings: query.data || [], ...query };
};
